import React from "react";
import { Plane, useTexture } from "@react-three/drei";

const GroundLogoPreview = ({ imageUrl, scale }) => {
  const [texture] = useTexture([imageUrl]);

  return (
    <Plane
      args={[1, 1]}
      scale={[scale, scale, scale]}
      rotation-x={-Math.PI / 2}
      position={[0, 0.025, 0]}
    >
      <meshBasicMaterial
        map={texture}
        transparent
        opacity={0.45}
        depthWrite={false}
      />
    </Plane>
  );
};

export default GroundLogoPreview;
